import { Component, OnDestroy, Inject, OnInit, ViewChild, DOCUMENT, signal, effect } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterOutlet } from '@angular/router'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'

import { navItems } from '../../_nav'
import { FuseqAuthService, FuseqService, FuseqUtils } from '../../FuseQ'
import { ClassManagerApiService } from '../../_services'
import { cloneDeep } from '../../../app/_helper/clone.util'
import { FuseqSessionService } from '../../FuseQ/session.service'
import { FuseqRaidenService } from '../../FuseQ/fuseq-raiden/fuseqRaiden.service'
import { RaidenSidebar } from '../../FuseQ/fuseq-raiden/fuseqRaiden.model'
import { Tabs } from '@openng/optimus-ui/tabs'
import { MessageService } from '@openng/optimus-ui/api'
import { SystemService } from '../../_services/systemService'
import { OptimUiSharedModule } from '../../shared/optimus-ui-shared.module';
import { NgxUiLoaderModule } from 'ngx-ui-loader'
import { HeaderComponent } from '../custom-layout/header.component'
import { AsideComponent } from '../custom-layout/aside.component'
import { FooterComponent } from '../custom-layout/footer.component'
import { SidebarComponent } from '../custom-layout/sidebar.component'
import { SidebarMinimizerComponent } from '../custom-layout/sidebar-minimizer.component'
import { SidebarNavComponent } from '../custom-layout/sidebar-nav.component'
import { HeaderFavoritesComponent } from '../custom-layout/header-favorites.component'
import { HeaderSiteSearchComponent } from '../custom-layout/header-site-search.component'
import { NavigationService } from '../../_shared/navigation/navigation.service'
import { EventMonitorComponent } from '../../FuseQ/fuseq-modules/eventMonitor/event-monitor.component'
import { SupportMenuComponent } from '../../FuseQ/fuseq-modules/supportMenu/support-menu.component'
import { MaintenanceBannerComponent } from '../../_shared/maintenance/maintenance-banner.component'
@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss'],
  imports: [OptimUiSharedModule,
    CommonModule,
    RouterOutlet,
    FontAwesomeModule,
    NgxUiLoaderModule,
    HeaderComponent,
    AsideComponent,
    FooterComponent,
    SidebarComponent,
    SidebarMinimizerComponent,
    SidebarNavComponent,
    HeaderFavoritesComponent,
    HeaderSiteSearchComponent,
    EventMonitorComponent,
    SupportMenuComponent,
    MaintenanceBannerComponent
  ]
})
export class DefaultLayoutComponent implements OnDestroy, OnInit {
  constructor (
    private readonly fuseqAuthService: FuseqAuthService,
    private readonly fuseqService: FuseqService,
    private readonly classApiService: ClassManagerApiService,
    private readonly fuseqUtils: FuseqUtils,
    private readonly fuseqUser: FuseqSessionService,
    private readonly fuseqRaiden: FuseqRaidenService,
    private readonly messageService: MessageService,
    private readonly systemService: SystemService,
    private readonly navigation: NavigationService,
    @Inject(DOCUMENT) _document?: any
  ) {
    this.currentUser = this.fuseqUser.session
    this.userlogin = this.fuseqUser.session.username
    this.navigation.init(this.currentUser?.username, this.currentUser?.id, this.currentUser?.options)
    this.fuseqRaiden.updateUserId(this.userlogin)
    this.changes = new MutationObserver((mutations) => {
      if (_document.body.classList.contains('brand-minimized')) {
        _document.body.classList.remove('brand-minimized') // to not minimize the brand
      }
    })
    this.element = _document.body
    this.changes.observe(this.element as Element, {
      attributes: true,
      attributeFilter: ['class']
    })
    effect(() => {
      const hierarchy = this.classApiService.classHierarchy()
      const base = this.baseNavItems()
      if (!hierarchy || !base || base.length === 0) {
        return
      }
      this.navItems.set(this.buildCatalogNav(cloneDeep(base), hierarchy.hierarchy))
    })
    effect(() => {
      this.navigation.setTree(this.navItems())
    })
  }

  @ViewChild('notificationsTabset') tabsetDetails: Tabs
  public sidebarMinimized = signal(false)
  userDropdownOpen = false
  eventDropdownOpen = false
  private readonly changes: MutationObserver
  public element: HTMLElement
  public navItems = signal<any[]>([])
  private readonly baseNavItems = signal<any[]>([])
  permittedMenuItems = []
  currentUser: any
  projectName: ''
  customerName: ''
  projectLogo
  projectLogoMinimized
  mainObjectsData
  activeAside: any = false
  userlogin = ''
  roomClients = signal<any[]>([])
  isFrozen = signal(false)
  showLiveEvents = false
  freeze () {
    this.isFrozen.set(true)
  }

  unfreeze () {
    this.isFrozen.set(false)
  }

  sendReaction (socketId) {
    this.fuseqRaiden.sendReaction(socketId)
  }

  ngOnInit () {
    this.fuseqRaiden.updateUserId(this.userlogin)
    this.projectName = this.fuseqService.getProjectInfo('projectName')
    this.customerName = this.fuseqService.getProjectInfo('customerName')
    this.projectLogo = this.fuseqService.getProjectInfo('projectLogo')
    this.projectLogoMinimized = this.fuseqService.getProjectInfo('progectLogoMinimized')
    // this.currentUser = this.authService.getUser();
    if (this.currentUser) {
      if (this.currentUser.permissions && this.currentUser.permissions.includes('MENU_ADMINISTRATION_CONFIGURATIONS')) {
        this.showLiveEvents = true
        this.fuseqRaiden.requestDesktopPermission()
        this.fuseqRaiden.subscribeToPush()
        this.fuseqRaiden.receiveReaction().subscribe((data: any) => {
          // this.toastr.info(`${data.reaction}`, `Reaction from ${data.from}`, { positionClass: 'toast-bottom-right' })
          this.isFrozen.set(true)
          this.roomClients().forEach(x => {
            if (x.socket_id === data.socket_id) {
              x.reaction = data.reaction
            }
          })
          setTimeout(() => { this.isFrozen.set(false) }, 5000)
        })
        this.fuseqRaiden.getRaidenRoomClients().subscribe(clients => {
          if (!this.isFrozen()) {
            this.roomClients.set(clients)
          } else {
            this.fuseqRaiden.showDesktopNotification('AWP - Speedtest', {
              body: 'Test in corso, attendere prego.',
              icon: '/assets/img/brand/awp_sq.png',
              // tag: 'awp-speedtest',
              requireInteraction: true
            })
          }
        })
        this.raidenList.set(this.fuseqRaiden.raidenSession)
        this.updateNotification()
        console.log(this.raidenList())
        this.activeAside = 'lg'
        this.raidenEvents()
      } else {
        try {
          document.body.classList.remove('aside-menu-lg-show')
        } catch (e) {

        }
      }
      if (this.currentUser.permissions.indexOf('OPERATOR') !== -1) {
        this.sidebarMinimized.set(true)
      }
      this.filterMenuByPermission(navItems, this.currentUser.permissions, this.permittedMenuItems)
      this.baseNavItems.set(cloneDeep(this.permittedMenuItems))
      this.navItems.set(cloneDeep(this.permittedMenuItems))

      this.classApiService.loadHierarchy().subscribe({
        next: () => {},
        error: (error) => {
          if (!error.isintercepted) {
            console.log(error)
          }
        }
      })
    }
  }

  toggleDarkMode () {
    /* this.isDarkMode = !this.isDarkMode
    const root = document.querySelector('html')
    root.classList.toggle('fq-dark-mode') */
    this.systemService.toggleDarkMode()
  }

  get isDarkMode () {
    return this.systemService.isDarkMode()
  }

  subscription = {
    SDWANInstallationEvent: null,
    SDWANSpeedtestEvent: null,
    SDWANMigrationEvent: null,
    activeTasksEvent: null
  }

  raidenList = signal<RaidenSidebar[]>([
    { name: 'CalendarEvents', active: true, showOptions: false, optionName: null, icon: 'fa fa-calendar', data: [] },
    {
      name: 'SDWANInstallationEvents',
      active: true,
      showOptions: true,
      optionName: 'SDWAN - Installazioni',
      options: [
        { name: 'Sidebar', active: true },
        { name: 'Popup', active: true }
      ],
      icon: 'fa fa-tower-cell',
      data: []
    },
    {
      name: 'SDWANMigrationEvents',
      active: true,
      showOptions: true,
      optionName: 'SDWAN - Migrazioni',
      options: [
        { name: 'Sidebar', active: true },
        { name: 'Popup', active: true }
      ],
      icon: 'fa fa-house-signal',
      data: []
    },
    {
      name: 'RakerEvents',
      active: true,
      showOptions: true,
      optionName: 'AWP - Raker',
      options: [
        { name: 'Sidebar', active: true },
        { name: 'Popup', active: true }
      ],
      icon: 'fa fa-file-import',
      data: []
    },
    {
      name: 'SDWANSpeedtestEvents',
      active: true,
      showOptions: true,
      optionName: 'SDWAN - Speedtest',
      options: [
        { name: 'Sidebar', active: true },
        { name: 'Popup', active: true }
      ],
      icon: 'fa fa-gauge',
      data: []
    },
    { name: 'Settings', active: true, showOptions: false, optionName: null, icon: 'fa fa-gears', data: [] }
  ])

  notificationCount = signal({
    total: 0,
    details: []
  })



  notification (notification) {
    console.log(notification, this.tabsetDetails.value())
    this.aside = true
    document.body.classList.add('aside-menu-lg-show')
    this.tabsetDetails.value.set(this.raidenList().findIndex(x => x.active && x.name == notification.name))
  }

  getRaidenNotificationConfig (name) {
    const config = { Sidebar: false, Popup: false }
    const search = this.raidenList().filter(x => x.name == name)
    if (search.length > 0 && search[0].options) {
      search[0].options.forEach(x => {
        config[x.name] = x.active
      })
    }
    return config
  }

  updateNotification () {
    this.fuseqRaiden.raidenSession = this.raidenList()
    const temp = {
      total: 0,
      details: []
    }
    this.raidenList().forEach(x => {
      const config = this.getRaidenNotificationConfig(x.name)
      if (x.data.length > 0 && config.Sidebar) {
        const notReadCount = x.data.filter(y => !y.markAsRead).length
        temp.total += notReadCount
        temp.details.push({ name: x.name, label: x.optionName, count: x.data.length, notReadCount, icon: x.icon })
      }
    })
    this.notificationCount.set(temp)
  }

  toggleRead (raiden: RaidenSidebar, msg: any) {
    this.raidenList.update(list => list.map(x => x.name === raiden.name
      ? { ...x, data: x.data.map(y => y.uniqueId === msg.uniqueId ? { ...y, markAsRead: !y.markAsRead } : y) }
      : x))
    this.updateNotification()
  }

  markAllAsRead (raiden) {
    this.raidenList.update(list => list.map(x => x.name === raiden.name ? { ...x, data: x.data.map(y => ({ ...y, markAsRead: true })) } : x))
    this.updateNotification()
  }

  clearAll (raiden) {
    this.raidenList.update(list => list.map(x => x.name === raiden.name ? { ...x, data: [] } : x))
    this.updateNotification()
  }

  checkAllRead (data) {
    if (data.length > 0) {
      return data.filter(x => x.markAsRead == true).length == data.length
    } else {
      return true
    }
  }

  checkSidebar (data) {
    if (data.options && data.options.length > 0) {
      if (data.options.filter(x => x.name == 'Sidebar' && x.active).length > 0) {
        return true
      }
      return false
    } else {
      return data.active
    }
  }

  changeSettings () {
    this.updateNotification()
  }
  // notifica run raker -> mary -> raiden toastr
  // notifica con scadenza temporale, countdown che va da 00:00 - now, oppure 5min in milliseconds
  // notifica su db + mark as read per utente

  raidenPush (name, data) {
    this.raidenList.update(list => list.map(x => {
      if (x.name === name) {
        const index = x.data.findIndex(d => d.uniqueId == data.uniqueId)
        if (index >= 0) {
          const nextData = [...x.data]
          nextData[index] = data
          return { ...x, data: nextData }
        }
        return { ...x, data: [...x.data, data] }
      }
      return x
    }))
    this.updateNotification()
  }

  activeTasksList = signal<any[]>([])
  raidenEvents () {
    this.subscription.SDWANInstallationEvent = this.fuseqRaiden.onSDWANInstallationEvent().subscribe((data) => {
      const config = this.getRaidenNotificationConfig('SDWANInstallationEvents')
      if (config.Sidebar) { this.raidenPush('SDWANInstallationEvents', data) }
      if (config.Popup) {
        this.messageService.add({ key: 'raiden', severity: 'info', summary: data.title, detail: data.description, data: { name: data.name, description: data.description, progress: data.progress } })
      }
    })
    this.subscription.SDWANMigrationEvent = this.fuseqRaiden.onSDWANMigrationEvent().subscribe((data) => {
      const config = this.getRaidenNotificationConfig('SDWANMigrationEvents')
      if (config.Sidebar) { this.raidenPush('SDWANMigrationEvents', data) }
      if (config.Popup) {
        this.messageService.add({ key: 'raiden', severity: 'info', summary: data.title, detail: data.description, data: { name: data.name, description: data.description, progress: data.progress } })
      }
    })
    this.subscription.SDWANSpeedtestEvent = this.fuseqRaiden.onSDWANSpeedtestEvent().subscribe((data) => {
      const config = this.getRaidenNotificationConfig('SDWANSpeedtestEvents')
      if (config.Sidebar) { this.raidenPush('SDWANSpeedtestEvents', data) }
      if (config.Popup) {
        this.messageService.add({ key: 'raiden', severity: 'info', summary: data.title, detail: data.description, data: { name: data.name, description: data.description, progress: data.progress } })
      }
    })
    this.subscription.activeTasksEvent = this.fuseqRaiden.onActiveTasksEvent().subscribe((data: any) => {
      this.activeTasksList.set(data.activeTask)
    })
  }

  ngOnDestroy (): void {
    this.subscription.SDWANInstallationEvent?.unsubscribe()
    this.subscription.SDWANMigrationEvent?.unsubscribe()
    this.subscription.SDWANSpeedtestEvent?.unsubscribe()
    this.subscription.activeTasksEvent?.unsubscribe()
  }

  logout () {
    this.fuseqAuthService.logout()
  }

  aside = false
  sidebarShown = false

  onSidebarToggled () {
    if (window.innerWidth <= 991) {
      this.sidebarShown = !this.sidebarShown
    } else {
      this.toggleMinimize(!this.sidebarMinimized())
    }
  }

  toggleMinimize (e) {
    this.sidebarMinimized.set(e)
  }

  private buildCatalogNav (navItems: any[], hierarchy: any[]): any[] {
    const classes = (hierarchy || []).filter(c => c.data.comment.ACTIVE != 'false')
    navItems.forEach(x => {
      if (x.name === 'Catalog') {
        x.children = x.children || []
        classes.forEach((c) => {
          const obj = this.buildCatalogItem(c, ['MENU_AWP_WORKFLOW_WORKFLOW', 'SYSADMIN_LOCAL'], '/admin/catalog/c/', x.icon)
          x.children.push(obj)
        })
      }
      if (x.name === 'Catalog v2' || x.name === 'Catalog V2') {
        x.children = x.children || []
        classes.forEach((c) => {
          const obj = this.buildCatalogItem(c, ['MENU_AWP_WORKFLOW_WORKFLOW', 'SYSADMIN_LOCAL'], '/admin/catalogv2/c/', x.icon)
          x.children.push(obj)
        })
      }
    })
    return navItems
  }

  private buildCatalogItem (c: any, key: any[], baseUrl: string, icon = ''): any {
    const obj = {
      name: (c.data.descr ? c.data.descr : c.label),
      url: baseUrl + c.data.classname + '/' + (c.data.descr ? c.data.descr : c.label),
      icon,
      key,
      children: null
    }
    if (c.children && c.children.length > 0) {
      obj.children = c.children.map(y => this.buildCatalogItem(y, [], baseUrl, icon))
    }
    return obj
  }

  filterMenuByPermission (navItems, permissions, permittedMenu) {
    if (navItems) {
      navItems.forEach((item: any, index) => {
        if (item.UIVersion) {
          item.name = this.currentUser.uiversion // UI Version taken on login
        }
        const isExist: boolean =
          item.title || item.divider || item.key === 'alwaysShow' ||
          this.fuseqUtils.checkArrays(item.key === undefined
            ? ['$#%^&']
            : typeof (item.key) === 'string'
              ? [item.key]
              : item.key, permissions)
        const cloneItem = { ...{}, ...item }
        if (isExist) { // || item.title || item.divider || item.key == 'alwaysShow'
          cloneItem.children = []
          permittedMenu.push(cloneItem)
        }
        if (item.children) {
          this.filterMenuByPermission(item.children, permissions, cloneItem.children)
        } else {
          delete cloneItem.children
        }
      })
    }
  }

  checkArrays (arr1, arr2) {
    let isExist = false
    arr1.forEach((item: any) => {
      if (arr2) {
        if (arr2.indexOf(item) > -1) {
          isExist = true
        }
      }
    })
    return isExist
  }
}
